import "./FilterChip.css";

function FilterChip({
  icon,
  label,
  rightIcon,
  active = false,
  disabled = false,
  onClick,
}) {
  const handleClick = (event) => {
    if (disabled) return;

    if (onClick) {
      onClick(event);
    }
  };

  return (
    <button
      type="button"
      className={`filter-chip ${active ? "active" : ""} ${
        disabled ? "disabled" : ""
      }`}
      onClick={handleClick}
      disabled={disabled}
      aria-pressed={active}
    >
      {icon && (
        <span className="chip-icon">
          {icon}
        </span>
      )}

      <span className="chip-label">
        {label}
      </span>

      {rightIcon && (
        <span className="chip-arrow">
          {rightIcon}
        </span>
      )}
    </button>
  );
}

export default FilterChip;